import clsx from 'clsx';

import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';

import type { SocialProfilesAndGroupsCondensedListProps } from '@/components/composite/SocialProfiles/SocialProfilesAndGroupsCondensedList';
// Components
import SocialProfilesAndGroupsCondensedList from '@/components/composite/SocialProfiles/SocialProfilesAndGroupsCondensedList';

type ItemWrapperProps = {
    spList: (SocialProfileType | SpGroupType)[];
    mainContent?: string;
    subContent?: string;
    size: SocialProfilesAndGroupsCondensedListProps['size'];
    className?: string;
    spClassName?: string;
};

const ItemWrapper = ({
    spList,
    mainContent,
    subContent,
    size = 'sm',
    className,
    spClassName
}: ItemWrapperProps) => {
    return (
        <div className={clsx('flex items-center space-x-3.5', className)}>
            <SocialProfilesAndGroupsCondensedList
                list={spList?.filter((p) => p?.active || p?.active === null)}
                size={size}
                className={spClassName}
            />

            <div className="flex-1 space-y-0.5 overflow-hidden">
                {mainContent ? (
                    <p className="overflow-hidden text-ellipsis whitespace-nowrap font-GSemiBold text-sm">
                        {mainContent}
                    </p>
                ) : null}

                {subContent ? (
                    <p className="overflow-hidden text-ellipsis whitespace-nowrap text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                        {subContent}
                    </p>
                ) : null}
            </div>
        </div>
    );
};

export default ItemWrapper;
